/**
 * Tenant slugs that can never be issued. Must match private.is_reserved_slug() in
 * supabase/migrations/20261015100000_staff_door_reserved_words.sql; the SQL function is authoritative.
 */
export const RESERVED_SLUGS: readonly string[] = [
  "admin",
  "app",
  "api",
  "auth",
  "www",
  "dash",
  "members",
  "mail",
  "smtp",
  "static",
  "cdn",
  "assets",
  "status",
  "docs",
  "help",
  "support",
  "billing",
  "how",
  "dcx",
  "dcxlogic",
  "sites",
  "web",
  "portal",
  "login",
  "logout",
  "test",
  "staging",
  "prod",
  "production",
  "dev",
  "local",
  "ns1",
  "ns2",
  "mx",
  "webhooks",
  "stripe",
  "sign-in",
  "choose",
  "me",
];
